export default function forbiddenResponse() {
  return {
    status: 'Access denied',
    statusText:
      'Access to this page is not enabled for your organization. Please contact support for more information.',
  };
}
